'use client';

import { FormDirtyContext } from '../declarative-form/FormDirtyContext';
import { useFormDirtyConfirm } from '../hooks/useFormDirtyConfirm';
import SheetWrapper from './SheetWrapper';

import type { ConfirmBeforeCloseConfig, SheetWrapperProps } from './SheetWrapper';

type DistributiveOmit<T, K extends keyof T> = T extends unknown ? Omit<T, K> : never;

interface FormSheetOwnProps {
  discardConfirmation?: Omit<ConfirmBeforeCloseConfig, 'when'>;
}

export type FormSheetProps = DistributiveOmit<SheetWrapperProps, 'confirmBeforeClose'> & FormSheetOwnProps;

export function FormSheet({
  children,
  discardConfirmation,
  ...props
}: FormSheetProps) {
  const { contextValue, confirmBeforeClose } = useFormDirtyConfirm();

  return (
    <FormDirtyContext.Provider value={contextValue}>
      <SheetWrapper
        confirmBeforeClose={{
          when: confirmBeforeClose,
          title: discardConfirmation?.title ?? 'Discard changes?',
          description: discardConfirmation?.description ?? 'The details you entered will be lost.',
          confirmText: discardConfirmation?.confirmText ?? 'Discard',
          cancelText: discardConfirmation?.cancelText ?? 'Keep editing',
        }}
        {...props}
      >
        {children}
      </SheetWrapper>
    </FormDirtyContext.Provider>
  );
}
